export var currentStateList = {
  none: 'none',
  requestForm: 'requestForm',
  success: 'success',
  fail: 'fail',
  loading: 'loading',
  abbreviated: 'abbreviated',
  captcha: 'captcha'
};